import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DocumentsService } from 'app/customer/documents/documents.service';
import { Document } from '../../customer/documents/contracts/document';
import { DocumentParams, AdditionalDocumentLables } from '../../customer/documents/enums/enum';
import { ApplicationService } from '../../application/application.service';
import { Application } from '../../application/application';
import { StatementsService } from '../../customer/statements/statements.service';
@Component({
  selector: 'zest-upload-card',
  templateUrl: './upload-card.component.html',
  styleUrls: ['./upload-card.component.scss']
})
export class UploadCardComponent implements OnInit {

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  uploadedAdditionalDocuments: Document[];
  validAdditionalDocumentFile = true;
  additionalDocument: AdditionalDocumentLables;
  invalidFileMessage: string;
  proofs = AdditionalDocumentLables;
  application: Application;
  DigioNach: boolean;
  errorMsg = '';
  digioQcFailed = false;

  constructor(
    private documentsService: DocumentsService,
    private applicationService: ApplicationService,
    private statementsService: StatementsService
  ) { }

  ngOnInit() {
    this.application = this.applicationService.getApplication();
    if (this.application) {
      this.statementsService.checkMerchantType(this.application.MerchantId).subscribe(response => {
        if (response.repaymentModes.includes('DIGIO_NACH')) {
          this.DigioNach = true;
        } else {
          this.DigioNach = false;
        }
      });
    } else {
      this.DigioNach = false;
    }
    this.getDocuments();
  }

  getDocuments() {
    this.documentsService.getDocuments().subscribe(response => {
      this.uploadedAdditionalDocuments = [];
      response.forEach(file => {
        if (file.isAdditionalDocument) {
          file.status = 2;
          this.uploadedAdditionalDocuments.push(file);
        }
      });
      this.uploadedAdditionalDocuments = this.documentsService.removeDuplicatesDocuments(this.uploadedAdditionalDocuments);
    });
  }

  selectFile(fileInput: any) {
    if (fileInput.target.files.length > 0 || fileInput.fileToSave) {
      if (((DocumentParams.imageFileFormats.indexOf(fileInput.fileToSave.type) > -1) ||
        (DocumentParams.pdfFileFormat.indexOf(fileInput.fileToSave.type) > -1))
        && fileInput.fileToSave.size > 0 && fileInput.fileToSave.size < DocumentParams.fileSize15Mb) {
        const reader = new FileReader();
        reader.readAsDataURL(fileInput.fileToSave);
        const re = /(?:\.([^.]+))?$/;
        let label = '';
        const doc = new Document();
        doc.fileName = fileInput.fileToSave.name.replace(/\.[^/.]+$/, '');
        doc.status = 0;
        this.validAdditionalDocumentFile = true;
        label = this.additionalDocument.toString();
        reader.onload = (event) => {
          doc.status = 1;
          if (label !== 'SignedNach') {
            this.documentsService.saveDocument('Other', label, fileInput.fileToSave.name.replace(/\.[^/.]+$/, ''), re.exec(fileInput.fileToSave.name)[1], reader.result.toString().split(',')[1], true).subscribe(response => {
              this.uploadedAdditionalDocuments.push(doc);
              doc.status = 2;
              this.getDocuments();
            }, error => {
              this.validAdditionalDocumentFile = false;
              this.getDocuments();
            });
          } else {
            const channel = 'reffered';
            const acceptedDigioExt = ['png', 'jpg'].indexOf(re.exec(fileInput.fileToSave.name)[1].toLowerCase());
            if (this.application) {
              this.statementsService.checkMerchantType(this.application.MerchantId).subscribe(response => {
                if (response.repaymentModes.includes('DIGIO_NACH')) {
                  if (acceptedDigioExt === -1) {
                    this.errorMsg = 'File should be in png or jpg format';
                    this.digioQcFailed = true;
                    this.validAdditionalDocumentFile = false;
                  } else {
                    this.documentsService.saveDigioDocumentInAdditionalDoc(fileInput.fileToSave.name.replace(/\.[^/.]+$/, ''), re.exec(fileInput.fileToSave.name)[1], reader.result.toString().split(',')[1], true, channel).subscribe(response => {
                        this.digioQcFailed = false;
                        this.uploadedAdditionalDocuments.push(doc);
                        doc.status = 2;
                        this.getDocuments();
                    }, error => {
                      this.errorMsg = 'Something went wrong please contact customer care';
                      this.validAdditionalDocumentFile = false;
                    });
                  }
                } else {
                  this.documentsService.saveDocument('Other', label, fileInput.fileToSave.name.replace(/\.[^/.]+$/, ''), re.exec(fileInput.fileToSave.name)[1], reader.result.toString().split(',')[1], true).subscribe(response => {
                    this.uploadedAdditionalDocuments.push(doc);
                    doc.status = 2;
                    this.getDocuments();
                  }, error => {
                    this.validAdditionalDocumentFile = false;
                    this.getDocuments();
                  });
                }
              });
            } else {
              this.documentsService.saveDocument('Other', label, fileInput.fileToSave.name.replace(/\.[^/.]+$/, ''), re.exec(fileInput.fileToSave.name)[1], reader.result.toString().split(',')[1], true).subscribe(response => {
                this.uploadedAdditionalDocuments.push(doc);
                doc.status = 2;
                this.getDocuments();
              }, error => {
                this.validAdditionalDocumentFile = false;
                this.getDocuments();
              });
            }
          }
        };
      } else {
        this.validAdditionalDocumentFile = false;
        if (fileInput.fileToSave.size >= DocumentParams.fileSize15Mb) {
          this.invalidFileMessage = 'File size should be less than 15 MB';
        } else {
          this.invalidFileMessage = 'Invalid File Type';
        }
      }
    }
  }

  closeUploader() {
    this.close.emit(true);
  }

}
